/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-08-17 18:55:59 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-09-24 12:41:57
 */

import * as wrappedModule from "exports-loader?Chartist!./chartist";

export default wrappedModule;



// WEBPACK FOOTER //
// ./app/components/Libs/chartist/index.js